import NavBar from './../nav/NavBar';

export const PageLayout = (props) => {
   return (<NavBar>{props.children}</NavBar>)
};